<div class="row mt-2">
    <div class="col-lg-12 col-md-12 col-sm-12 m-auto text-center">
        <p class="title mb-0">Cadastro de nova empresa</p>
    </div>
</div>

<div class="row mb-2">
    <div class="col-lg-12 col-md-12 col-sm-12 m-auto text-center">
        <p class="subtitle">Preencha os dados a seguir:</p>
    </div>
</div>

<div class="row my-3">
    <div class="col-lg-9 col-md-9 col-sm-12 m-auto">
        <form [formGroup]="gestorCadastroFormGroup" #gestorCadastroForm="ngForm" (ngSubmit)="onSubmit(gestorCadastroFormGroup.value)">
            <div class="py-2">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 vl-right">
                        <div class="custom-pr-5">
                            <div class="input-container">
                                <input autocomplete="off" formControlName="companyName" id="companyName" class="input" type="text"/>
                                <label class="label" for="companyName">Nome da empresa</label>
                            </div>
                            <div *ngIf="form.companyName.invalid && (form.companyName.dirty || form.companyName.touched)" class="text-danger">
                                <div *ngIf="form.companyName.errors.required">
                                    Nome da empresa é obrigatório
                                </div>
                                <div *ngIf="form.companyName.errors.minlength">
                                    Nome da empresa deve conter mais de 2 letras
                                </div>
                                <div *ngIf="form.companyName.errors.maxlength">
                                    Nome da empresa deve conter no máximo 100 letras
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pl-5">
                            <div class="input-container div-select">
                                Número de funcionários:
                                <select formControlName="numberOfEmployees">
                                    <option disabled value="">Selecione...</option>
                                    <option value="1 a 10 colaboradores">1 a 10 colaboradores</option>
                                    <option value="10 a 49 colaboradores">10 a 49 colaboradores</option>
                                    <option value="50 a 99 colaboradores">50 a 99 colaboradores</option>
                                    <option value="100 a 499 colaboradores">100 a 499 colaboradores</option>
                                    <option value="500 a 1999 colaboradores">500 a 1999 colaboradores</option>
                                    <option value="+2000 colaboradores">+2000 colaboradores</option>
                                </select>
                            </div>
                            <div *ngIf="form.numberOfEmployees.invalid && (form.numberOfEmployees.dirty || form.numberOfEmployees.touched)" class="text-danger">
                                <div *ngIf="form.numberOfEmployees.errors.required">
                                    Selecione um valor
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 vl-right">
                        <div class="custom-pr-5">
                            <div class="input-container">
                                <input autocomplete="off" formControlName="nome" id="nome" class="input" type="text"/>
                                <label class="label" for="nome">Nome completo do representante</label>
                            </div>
                            <div *ngIf="form.nome.invalid && (form.nome.dirty || form.nome.touched)" class="text-danger">
                                <div *ngIf="form.nome.errors.required">
                                    Nome do representante é obrigatório
                                </div>
                                <div *ngIf="form.nome.errors.minlength">
                                    Nome deve conter mais de 3 letras
                                </div>
                                <div *ngIf="form.nome.errors.maxlength">
                                    Nome deve conter no máximo 100 letras
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pl-5">
                            <div class="input-container">
                                <input formControlName="cpf" [textMask]="{mask: MASKS.cpf.textMask}" id="cpf" class="input" type="text" [(ngModel)]="inDocumento" (blur)="CompleteWithZero()" autocomplete="off"/>
                                <label class="label" for="cpf">CPF</label>
                            </div>
                            <div *ngIf="form.cpf.invalid && (form.cpf.dirty || form.cpf.touched)" class="text-danger">
                                <div *ngIf="form.cpf.errors.required">
                                    CPF é obrigatório
                                </div>
                                <div *ngIf="form.cpf.errors.cpf">
                                    CPF inválido
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>

                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 vl-right">
                        <div class="custom-pr-5">
                            <div class="input-container">
                                <input autocomplete="off" formControlName="telefoneNumero" [textMask]="{mask: telefoneCelularMask}" id="telefoneNumero" class="input" type="text"/>
                                <label class="label" for="telefoneNumero">Telefone celular</label>
                            </div>
                            <div *ngIf="form.telefoneNumero.invalid && (form.telefoneNumero.dirty || form.telefoneNumero.touched)" class="text-danger">
                                <div *ngIf="form.telefoneNumero.errors.required">
                                    Telefone é obrigatório
                                </div>
                                <div *ngIf="form.telefoneNumero.errors.celular">
                                    Telefone inválido
                                </div>
                                <div *ngIf="form.telefoneNumero.errors.isCellPhone">
                                    Telefone deve conter o dígito 9
                                </div>
                                <div *ngIf="form.telefoneNumero.errors.telefone">
                                    Telefone inválido
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pl-5">
                            <div class="input-container">
                                <div class="date-div-label">Data de nascimento</div>
                                <div class="input-group">
                                    <input formControlName="dataNascimento" maxlength="10" [options]="
                                            myDatePickerOptions
                                        " angular-mydatepicker #dp="angular-mydatepicker" class="form-control input-data" name="dataNascimento" (keyup)="dateMask($event)" [maxlength]="10" autocomplete="off"/>
                                    <button type="button" class="btn input-group-append input-group-text p-0 calendar-btn" (click)="
                                            dp.toggleCalendar()
                                        "></button>
                                </div>
                            </div>
                            <div *ngIf="form.dataNascimento.invalid && (form.dataNascimento.dirty || form.dataNascimento.touched)" class="text-danger">
                                <div *ngIf="form.dataNascimento.errors.required">
                                    Data de nascimento é obrigatória
                                </div>
                                <div *ngIf="form.dataNascimento.errors.isAdult">
                                    O responsável deve ter mais de 18 anos
                                </div>
                                <div *ngIf="form.dataNascimento.errors.lockDate">
                                    Data inválida
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 vl-right">
                        <div class="custom-pr-5">
                            <div class="input-container">
                                <input formControlName="email" id="email" class="input" type="email" autocomplete="new-password"/>
                                <label class="label" for="email">E-mail corporativo</label>
                            </div>
                            <div *ngIf="form.email.invalid && (form.email.dirty || form.email.touched)"
                                class="text-danger">
                                <div *ngIf="form.email.errors.required">
                                    E-mail é obrigatório
                                </div>
                                <div *ngIf="form.email.errors.email">
                                    Formato de e-mail inválido
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pl-5">
                            <div class="input-container">
                                <input formControlName="emailConfirmacao" id="emailConfirmacao" class="input"
                                    type="email" autocomplete="new-password"/>
                                <label class="label" for="emailConfirmacao">Confirmar e-mail corporativo</label>
                            </div>
                            <div *ngIf="form.emailConfirmacao.invalid && (form.emailConfirmacao.dirty || form.emailConfirmacao.touched)"
                                class="text-danger">
                                <div *ngIf="form.emailConfirmacao.errors.required">
                                    E-mail é obrigatório
                                </div>
                                <div *ngIf="form.emailConfirmacao.errors.email">
                                    Formato de e-mail inválido
                                </div>
                                <div *ngIf="form.emailConfirmacao.errors.mustMatch">
                                    Os e-mails devem coincidir
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row button-container">
                    <div class="col-12 d-flex justify-content-end">
                        <button [disabled]="!gestorCadastroForm.valid" type="submit" class="button">
                            <span>Próximo</span>
                            <img src="./assets/icons/arrow-right.svg">
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

<!-- Google Tag Manager (noscript) -->
<noscript>
    <iframe src="https: //www.googletagmanager.com/ns.html?id=GTM-WVBRX6X"
        height="0" width="0" style="display:none;visibility:hidden">
    </iframe>
</noscript> 
<!--End Google Tag Manager(noscript) -->